import React from 'react'
import { Editor } from '@tiptap/core'
import { SlashCommandTriggerButtonProps } from './types.js'
import { Button } from '../Button/Button.jsx'
import { Icon } from '../Icon.js'
import { Plus } from 'lucide-react'

export const SlashCommandTriggerButton = ({ editor, config }: SlashCommandTriggerButtonProps) => {
  if (!editor) {
    return null
  }

  const handleClick = () => {
    // Insert a slash command trigger
    editor.chain().focus().insertContent('/').run()
  }

  return (
    <Button
      variant="ghost"
      buttonSize="small"
      onClick={handleClick}
      className="flex items-center gap-2 text-neutral-500 hover:text-black"
    >
      <Icon icon={Plus} className="w-4 h-4" />
      <span className="text-sm font-medium">Insert</span>
    </Button>
  )
}
